import { useMemo } from "react"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import Tabs from "@mui/material/Tabs"
import Badge from "@mui/material/Badge"

import type { Tab } from "types/tabs.types"

import { getTabValue } from "helpers/config/tabs/helpers"
import { TAB_ICONS } from "helpers/config/tabs/tabIconsConfig"
import { TabsContainer } from "widgets/styled/containers"
import { LinkTab } from "widgets/styled/widgets"

interface LinkTabsSectionProps {
  tabsConfig: Tab[]
  badges?: Record<string, boolean>
}

const LinkTabsSection = ({ tabsConfig, badges }: LinkTabsSectionProps) => {
  const location = useLocation()
  const { t } = useTranslation()

  const tabValue = useMemo(() => {
    const path = location.pathname
    return getTabValue(path, tabsConfig)
  }, [location.pathname, tabsConfig])

  return (
    <TabsContainer>
      <Tabs
        value={tabValue}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          "& .MuiTabs-scrollButtons": {
            width: 28,
          },
        }}
      >
        {tabsConfig.map((tab) => (
          <LinkTab
            key={tab.value}
            label={t(tab.labelKey)}
            icon={
              badges?.[tab.labelKey] ? (
                <Badge color="error" variant="dot">
                  {TAB_ICONS[tab.labelKey]}
                </Badge>
              ) : (
                TAB_ICONS[tab.labelKey]
              )
            }
            iconPosition="start"
            value={tab.value}
            to={tab.to}
            replace
          />
        ))}
      </Tabs>
    </TabsContainer>
  )
}

export default LinkTabsSection
